var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAckoLogoHalfBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 122,
    viewBox: "0 0 158 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    stroke: "#B191ED",
    strokeOpacity: 0.2,
    strokeWidth: 1.171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.352 16.989v49.55c0 3.626-1.635 6.76-4.937 8.93-41.363 27.097-72.684 38.491-83.638 41.657-15.115 4.371-23.124 3.91-24.423 3.815-27.59-1.991-74.655-41.604-74.655-41.604s38.512 10.88 126.133-30.828c16.426-7.82 34.759-16.258 56.08-26.143 0 0 5.44-2.662 5.44-5.387v.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.353 17.073c0-3.375-2.778-5.073-4.937-6.54-40.849-27.852-72.673-38.492-83.627-41.657-15.116-4.371-23.124-3.91-24.424-3.816-27.59 1.992-70.996 37.18-75.45 42.411 0 0 39.307-11.698 126.928 30.01 2.82 1.343 7.998 3.858 11.237 5.714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.313 76.36s-.598-1.74-.975-3.26c-2.317-9.968-3.585-20.052-3.627-30.136.052-10.084 1.31-20.167 3.627-30.136.471-1.96.733-2.768.733-2.768M13.914 7.47s-1.363 1.143-3.218 3.48C4.522 19.138.99 30.805 1 42.965c0 12.159 3.407 24.517 9.58 32.704 1.038 1.373 3.607 3.763 5.41 4.172"
  }))));
}
export default SvgAckoLogoHalfBig;